import { fetch } from '@/utils/request';

/*
 * HubSpot 接口由 portal-framework 实现（替代原 nginx `/hubspot/` 反代，见 docs/hubspot.md）。
 * 身份由服务端从登录态取，不传任何参数，只能读写当前用户自己那条联系人。
 * 失败时 success 为 false，code 为 notConfigured / unauthorized / rateLimited / upstreamFailed。
 *
 * 用 fetch 而不是 request：zenFetch 对任何状态码都 resolve，request 只留响应体，
 * 调用方要靠 status 区分「网关拦下（401/403）」和「服务端失败（200 + success:false）」。
 */
const PREFIX = '/api/portal-framework/hubspot';

/** 把当前登录用户的姓名写进 HubSpot（服务端 batch/upsert）。员工账号服务端直接跳过。 */
export function syncHubspotContact() {
  return fetch<RequestRes<{ skipped: boolean }>>({
    method: 'POST',
    url: `${PREFIX}/contact/sync`,
  });
}

/** 读当前登录用户的 HubSpot 归因字段。查不到时 found 为 false。 */
export function getHubspotAttribution() {
  return fetch<
    RequestRes<{ found: boolean; properties: Record<string, string | null> }>
  >({
    method: 'GET',
    url: `${PREFIX}/attribution`,
  });
}
